import { render, staticRenderFns } from "./detail-jishen.vue?vue&type=template&id=236c6f42&scoped=true"
import script from "./detail-jishen.vue?vue&type=script&lang=js"
export * from "./detail-jishen.vue?vue&type=script&lang=js"
import style0 from "./detail-jishen.vue?vue&type=style&index=0&id=236c6f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c6f42",
  null
  
)

export default component.exports